module.exports = __webpack_public_path__ + "assets/img/Background.a2854a0f.png";